import { get } from 'lodash'

import { accommodation } from '../../api/api'

export const FETCH_ACCOMMODATION_BEGIN = 'FETCH_ACCOMMODATION_BEGIN'
export const FETCH_ACCOMMODATION_SUCCESS = 'FETCH_ACCOMMODATION_SUCCESS'
export const FETCH_ACCOMMODATION_ERROR = 'FETCH_ACCOMMODATION_ERROR'

export const fetchAccommodation = () => async (dispatch, getState) => {
  dispatch({ type: FETCH_ACCOMMODATION_BEGIN })

  const brand = get(getState(), 'configurationData.data.brand')
  const id = get(getState(), 'configurationData.data.accommodationId')
  const response = await accommodation(brand, id)

  dispatch({
    type: FETCH_ACCOMMODATION_SUCCESS,
    payload: response,
  })
}
